export default "__VITE_ASSET__CETeZtEK__"